// BidProjectButton.jsx
import React, { useState } from "react";
import { FaCheckSquare } from "react-icons/fa";
import { toast } from "react-toastify";

const GoogleMetrikaProjectButton = ({ projectId }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/metrika/bider_one_project", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ project_id: projectId }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Проект отправлен на бидера");
      } else {
        toast.error(data.error || "Ошибка при отправке");
      }
    } catch (err) {
      console.error("Ошибка сети:", err);
      toast.error("Ошибка сети");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      title="метрика в гугл"
      style={{
        background: "transparent",
        border: "none",
        cursor: "pointer",
        color: loading ? "#ccc" : "#28a745",
        fontSize: "18px",
      }}
    >
      <FaCheckSquare />
    </button>
  );
};

export default GoogleMetrikaProjectButton;
